import Immutable from 'immutable';
import { AsyncAction } from 'rxjs/scheduler/AsyncAction';

export const getHomeVerifyStarted = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.request, 'homeVerify', 'loading'
    ], true).setIn([
        'workOrderDetails', action.request, 'homeVerify', 'homeVerifyError'
    ], null);
};

export const getHomeVerifyFailed = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.request, 'homeVerify', 'loading'
    ], false).setIn([
        'workOrderDetails', action.request, 'homeVerify', 'homeVerifyError'
    ], 'Getting home verify status failed. Please try again.');
};

export const getHomeVerifyFinished = (state, action) => {    
    return state.setIn(['workOrderDetails', action.orderId, 'homeVerify', 'loading'], false)
    .setIn(['workOrderDetails', action.orderId, 'homeVerify', 'details'], action.payload ? Immutable.fromJS(action.payload[0]) : null);
};

export const setHomeVerifyStarted = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.request.serviceOrder, 'homeVerify', 'loading'
    ], true).setIn([
        'workOrderDetails', action.request.serviceOrder, 'homeVerify', 'homeVerifyError'
    ], null);
};

export const setHomeVerifyFailed = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.request.serviceOrder, 'homeVerify', 'loading'
    ], false).setIn([
        'workOrderDetails', action.request.serviceOrder, 'homeVerify', 'homeVerifyError'
    ], 'Setting home verify status failed. Please try again.');
};

export const setHomeVerifyFinished = (state, action) => {
    return state.setIn(['workOrderDetails', action.request, 'homeVerify', 'loading'], false)
        .setIn(['workOrderDetails', action.request, 'homeVerify', 'homeVerifyError'
    ], null);
};

export const setHomeVerifyState = (state, action) => {
    return state.setIn(['workOrderDetails', action.orderId, 'homeVerify', 'homeVerifyState'], action.homeVerifyState);
};

export const setHomeVerifyMessage = (state, action) => {
    return state.setIn(['workOrderDetails', action.orderId, 'homeVerify', 'message'], action.message);
};


// WEBPACK FOOTER //
// ./src/reducers/work-order/homeVerify.js